import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { useApiClient } from "@services/Api/ApiClientContext";
import { useSelectedEvent } from "@app/panel/Events/contexts/SelectedEvent.context";
import { useEventsModals } from "@app/panel/Events/contexts/EventsModals.context";

import Portal from "@components/overlay/Portal/Portal";
import Backdrop from "@components/ux/Backdrop/Backdrop";
import Modal from "@components/overlay/Modal/Modal";
import Stack from "@components/arrangement/Stack/Stack";
import Group from "@components/arrangement/Group/Group";
import Button from "@components/dataEntry/Buttons/Button/Button";

import "./SendAllNfts.scss";

const SendAllNfts = () => {
  const [submitting, setSubmitting] = useState<boolean>(false);

  const { event } = useSelectedEvent();
  const { closeModal } = useEventsModals();
  const { sendNftsToAllSubmissions } = useApiClient();

  const { t } = useTranslation(["eventsModals", "common"]);

  const handleSendGroupTickets = () => {
    setSubmitting(true);

    sendNftsToAllSubmissions(event.id)
      .then((res) => {
        if (res.status === 204) {
          closeModal();
        }
      })
      .finally(() => setSubmitting(false));
  };

  return (
    <Portal>
      <Backdrop open>
        <Modal onClose={closeModal}>
          <Stack className="send-all-nfts-modal">
            <p className="p0 mt-3">{t("eventsModals:sendAllNfts.description")}</p>

            <Group colGap={20} className="mt-5">
              <Button type="submit" variant="primary" onClick={handleSendGroupTickets} disabled={submitting}>
                {t("common:send")}
              </Button>
              <Button variant="secondary" onClick={closeModal}>
                {t("common:cancel")}
              </Button>
            </Group>
          </Stack>
        </Modal>
      </Backdrop>
    </Portal>
  );
};

export default SendAllNfts;
